var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNeutralGreyArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 18",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.414,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 .5A8.498 8.498 0 001.5 9c0 4.695 3.804 8.5 8.5 8.5A8.5 8.5 0 0018.5 9c0-4.696-3.805-8.5-8.5-8.5z",
    fill: "#A6CEE3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeutralGreyArrow);
export default __webpack_public_path__ + "static/media/neutral-grey-arrow.c0db1588815cc21198c4aad4a1140979.svg";
export { ForwardRef as ReactComponent };